module.exports = __webpack_public_path__ + "media/images/warning-icon-ccbd34ce89013e52c1591377fb0f73fe7aaefc6a89a65a459e7a4962672601b5.svg";